/**
 * Created by bing on 2018/3/30.
 */
module.exports = function (Vue) {
  let that = new Vue()
  let host = that.globalData.host
  Vue.prototype.$http$ = function (option, success, error) {
    let url = option.url, method = option.method || 'get'
      , data = option.data || {}, load = option.load || null,backDirect = option.backDirect || false,dirUrl=option.dirUrl || false
    let path = host + url
    if(dirUrl){
      path = url
    }
    if(load){
      this.$store.commit('setLoading',load)
    }

    //this.$store.state.LoginUser
      let headers = {};

      try {
          headers = {
              "accessToken":this.$store.state.LoginUser.accessToken||""

          }
      }
      catch(err){

      }




    if (method == 'get') {
      this.$http.get(path, {params: data, headers:headers})
        // .then((ret) => {debugger})
        .then((ret) => ret.body)
        .then((data) => {
          if(backDirect){
            success(data)
            return
          }
          if(load){
            this.$store.commit('cancelLoading',load)
          }
          if (data.code == 200) {
            success(data.data)
          } else if (data.code == 401) {
            window.location.href = 'login.html'
          } else {
            if (error) {
              error()
            } else {
              this.$error(data.msg)
            }
          }
        })
        .catch((e) => {
        console.log(e)
          if(load){
            this.$store.commit('cancelLoading',load)
          }
          console.error(e);
          this.$error('网络异常...')
        })
    } else if (method == 'delete') {
      this.$http.delete(path, {params: data, headers:headers})
        .then((ret) => ret.body)
        .then((data) => {
          if(backDirect){
            success(data)
            return
          }
          if(load){
            this.$store.commit('cancelLoading',load)
          }
          if (data.code == 200) {
            success(data.data)
          } else if (data.code == 401) {
            window.location.href = 'login.html'
          } else {
            if (error) {
              error()
            } else {
              this.$error(data.msg)
            }
          }
        })
        .catch((e) => {
          console.log(e)
          if(load){
            this.$store.commit('cancelLoading',load)
          }
          console.error('error');
          this.$error('网络异常...')
        })
    } else if (method == 'post') {
      this.$http.post(path, data,{
          headers:headers
      })
        .then((ret) => ret.body)
        .then((data) => {
          if(backDirect){
            success(data)
            return
          }
          if(load){
            this.$store.commit('cancelLoading',load)
          }
          if (data.code == 200) {
            success(data.data)
          } else if (data.code == 401) {
            window.location.href = 'login.html'
          } else {
            if (error) {
              error()
            } else {
              this.$error(data.msg)
            }
          }
        })
        .catch((e) => {
          console.log(e)
          if(load){
            this.$store.commit('cancelLoading',load)
          }
          console.error('error');
          this.$error('网络异常...')
        })
    } else if (method == 'put') {
      this.$http.put(path, data,{
          headers:headers
      })
        .then((ret) => ret.body)
        .then((data) => {
          if(backDirect){
            success(data)
            return
          }
          if(load){
            this.$store.commit('cancelLoading',load)
          }
          if (data.code == 200) {
            success(data.data)
          } else if (data.code == 401) {
            window.location.href = 'login.html'
          } else {
            if (error) {
              error()
            } else {
              this.$error(data.msg)
            }
          }
        })
        .catch((e) => {
          console.log(e)
          if(load){
            this.$store.commit('cancelLoading',load)
          }
          console.error('error');
          this.$error('网络异常...')
        })
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/http.js